export class Payment {
    amount: number;
    _id: string;
    payment_no: number;
    paymentid: string;
    payment: string;
    payment_method: string;
}
